import { ArrowLeft, BookOpen, Settings, Volume2, VolumeX } from "lucide-react";
import { FullscreenButton } from "./FullscreenButton";

interface HudProps {
  title: string;
  chapterLabel?: string;
  stepLabel?: string;
  stepCurrent?: number;
  stepTotal?: number;
  soundEnabled: boolean;
  onToggleSound: () => void;
  onOpenPassage: () => void;
  onOpenSettings: () => void;
  onOpenMap: () => void;
  showPassage?: boolean;
}

// 顶部 HUD 仅保留必要工具，避免遮挡中央观察区域。
export function Hud({
  title,
  chapterLabel,
  stepLabel,
  stepCurrent,
  stepTotal,
  soundEnabled,
  onToggleSound,
  onOpenPassage,
  onOpenSettings,
  onOpenMap,
  showPassage = true
}: HudProps) {
  return (
    <header className="hud">
      <div className="hud__identity">
        <button className="hud__back" type="button" onClick={onOpenMap} title="返回旅程地图" aria-label="返回旅程地图">
          <ArrowLeft size={18} />
          <span>旅程地图</span>
        </button>
        <div>
          {chapterLabel && <span className="hud__eyebrow">{chapterLabel}</span>}
          <strong>{title}</strong>
        </div>
      </div>
      {stepLabel && stepCurrent && stepTotal && (
        <div className="hud__scene-progress" aria-label={`当前步骤 ${stepCurrent}/${stepTotal}`}>
          <span>{stepLabel}</span>
          <div>{Array.from({ length: stepTotal }, (_, index) => <i key={index} className={index < stepCurrent ? "is-reached" : ""} />)}</div>
          <small>{stepCurrent}/{stepTotal}</small>
        </div>
      )}
      <div className="hud__tools">
        {showPassage && (
          <button className="hud__tool" type="button" onClick={onOpenPassage} title="查看课文" aria-label="查看课文">
            <BookOpen size={19} />
            <span>课文</span>
          </button>
        )}
        <button className="hud__tool" type="button" onClick={onToggleSound} title={soundEnabled ? "关闭声音" : "开启声音"} aria-label={soundEnabled ? "关闭声音" : "开启声音"}>
          {soundEnabled ? <Volume2 size={19} /> : <VolumeX size={19} />}
          <span>{soundEnabled ? "声音" : "静音"}</span>
        </button>
        <FullscreenButton />
        <button className="hud__tool" type="button" onClick={onOpenSettings} title="设置" aria-label="设置">
          <Settings size={19} />
          <span>设置</span>
        </button>
      </div>
    </header>
  );
}
